import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Link } from "react-router-dom";

import { fetchPriceAnomalyRule } from "../api/priceAnomalyRule";
import { useSession } from "../auth/useSession";
import { canManageSources } from "../lib/role";
import { PriceAnomalyRuleCard } from "./PriceVarianceReportPage";

/**
 * Einstellungen im Konto-Menü (#630): betriebliche Regeln an einer Stelle statt
 * in einem Aufklapper der Analyse.
 */
export default function SettingsPage() {
  const { user } = useSession();
  const queryClient = useQueryClient();
  const ruleQuery = useQuery({ queryKey: ["price-anomaly-rule"], queryFn: fetchPriceAnomalyRule });
  return (
    <main className="mx-auto max-w-4xl px-6 py-6">
      <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Einstellungen</h1>

      <section aria-labelledby="settings-rule" className="mt-6">
        <h2 id="settings-rule" className="text-lg font-semibold tracking-tight text-slate-900">Preisprüfung</h2>
        <p className="mt-1 text-sm text-slate-600">Ab wann eine Rechnungsposition zur Prüfung erscheint. Gilt für Rechnungsprüfung und Analyse.</p>
        {ruleQuery.data ? (
          <PriceAnomalyRuleCard rule={ruleQuery.data} onSaved={(next) => queryClient.setQueryData(["price-anomaly-rule"], next)} />
        ) : ruleQuery.isError ? (
          <p role="alert" className="mt-3 text-sm text-rose-700">Die Prüfregel konnte nicht geladen werden.</p>
        ) : (
          <p className="mt-3 text-sm text-slate-600">Lade Prüfregel …</p>
        )}
      </section>

      {canManageSources(user) ? (
        <section aria-labelledby="settings-sources" className="mt-8">
          <h2 id="settings-sources" className="text-lg font-semibold tracking-tight text-slate-900">Datenquellen</h2>
          <p className="mt-1 text-sm text-slate-600">Wie Belege der Großhändler erkannt und eingelesen werden.</p>
          <Link to="/coverage?tab=profiles" className="mt-3 inline-flex h-9 items-center rounded-md border border-slate-300 bg-white px-3 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50">
            Datenquellen öffnen →
          </Link>
        </section>
      ) : null}
    </main>
  );
}
